import { Link } from "react-router-dom";

const SubscriptionRenewalReminder = ({
  packageExpireDate,
  showNotification,
  setShowNotificationForRenewSubscription,
}) => {
  if (!showNotification) return null;

  return (
    <div className="tw-text-[14px] tw-bg-yellow-600 tw-text-white tw-text-center tw-p-3 tw-rounded-lg tw-mb-4 tw-flex tw-justify-between tw-items-center tw-gap-2">
      <span>
        ⚠️ Your subscription will expire on{" "}
        {packageExpireDate && (
          <strong>{new Date(packageExpireDate).toLocaleDateString()}</strong>
        )}
        .
        <Link
          to={"/renew-subscription"}
          className="tw-mx-1 tw-underline tw-font-bold"
        >
          Renew it now
        </Link>
        to avoid deactivation of your account
      </span>
      <button
        onClick={() => setShowNotificationForRenewSubscription(false)}
        className="tw-ml-4 tw-bg-white tw-text-yellow-500 tw-px-3 tw-py-1 tw-rounded-lg tw-text-sm"
      >
        Dismiss
      </button>
    </div>
  );
};

export default SubscriptionRenewalReminder;
